import { render, staticRenderFns } from "./BajaLocDialogComponent.vue?vue&type=template&id=c8c50b60&scoped=true"
import script from "./BajaLocDialogComponent.vue?vue&type=script&lang=js"
export * from "./BajaLocDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./BajaLocDialogComponent.vue?vue&type=style&index=0&id=c8c50b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c50b60",
  null
  
)

export default component.exports